import { inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/tip.action';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { TipService } from '../../services';

export const LoadTips$ = createEffect(
  (actions$ = inject(Actions), service = inject(TipService)) => {
    return actions$.pipe(
      ofType(actions.LoadTips),
      switchMap(() =>
        service.getTips().pipe(
          map(tip => actions.LoadTipsSuccess({ tip })),
          catchError(error => of(actions.LoadTipsFail({ error })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadInsightsTips$ = createEffect(
  (actions$ = inject(Actions), service = inject(TipService)) => {
    return actions$.pipe(
      ofType(actions.LoadInsightsTips),
      switchMap(() =>
        service.getInsightsTips().pipe(
          map(tip => actions.LoadInsightsTipsSuccess({ tip })),
          catchError(error => of(actions.LoadInsightsTipsFail({ error })))
        )
      )
    );
  },
  { functional: true }
);
